import { classnames } from '@/helpers';
import { Fragment } from 'react/jsx-runtime';
import { twMerge } from 'tailwind-merge';

type Options = {
  filter?: boolean; // <-- Whether to filter out non matching suggestions
  className?: string; // <-- Class name to apply to the highlighted text
};

const HighlightMatch = ({ text, query, options }: { text: string; query: string; options?: Options }) => {
  if (!query) return options.filter ? null : <span>{text}</span>;

  const lowerText = text.toLowerCase();
  const lowerQuery = query.toLowerCase();
  const matchIndex = lowerText.indexOf(lowerQuery);

  if (matchIndex === -1) return options.filter ? null : <span>{text}</span>;

  const before = text.slice(0, matchIndex);
  const match = text.slice(matchIndex, matchIndex + query.length);
  const after = text.slice(matchIndex + query.length);

  return (
    <Fragment>
      <span>{before}</span>
      <strong className={twMerge('font-bold', classnames(options?.className && options.className))}>{match}</strong>
      <span>{after}</span>
    </Fragment>
  );
};

export default HighlightMatch;
